<template>
    <div style="display: flex;height: 100%;padding: 6px;gap: 12px;">
        <StationSide @node-click="nodeClick"/>
        <div class="ag-theme-material" style="height: 100%;flex: 1;">
            <ag-grid-vue 
                style="width: 100%; height: 100%;"
                :suppressNoRowsOverlay="true"
                autoSizePadding="10"
                editType="fullRow"
                :rowHeight="40"
                :headerHeight="40"
                :gridReady="onGridReady"
                :columnDefs="columnDefs"
                :rowData="rowData"
            >
        </ag-grid-vue>
        <ELDialog ref="ELDialogRef" :closeCallBack="resetForm">
            <template slot="mytitle">
                <span>{{ title }}</span>
            </template>
            <template slot="mybody">
                <div>
                    <Form ref="form" :model="form" :inline="inline" label-position="top" >
                        <div style="display: grid;grid-template-columns: repeat(4,minmax(0,1fr));gap:0 16px;">
                                <FormItem :label="item.label" :prop="item.prop" :rules="item.rules" v-for="(item,index) in formData.filter(item=>item.show)" :key="item.prop">
                                    <template v-if="item.type=='Input'">
                                        <Input v-model="form[item.prop]" :placeholder="item.placeholder">
                                            <template slot="append" v-if="item.append">
                                                <span>{{ item.append }}</span>
                                            </template>
                                        </Input>
                                    </template>
                                    <template v-else-if="item.type=='Radio'">
                                        <RadioGroup v-model="form[item.prop]" style="width: 100%;">
                                            <Radio v-for="source in item.options" :key="source.value" :label="source.value">{{source.label}}</Radio>
                                        </RadioGroup>
                                    </template>
                                    <template v-else-if="item.type=='Select'">
                                        <Select v-model="form[item.prop]">
                                            <template v-if="item.api">
                                                <Option v-for="source in apiData[item.api]" :key="source.value" :value="source.value">{{source.label}}</Option>
                                            </template>
                                            <template v-else>
                                                <Option v-for="source in item.options" :key="source.value" :value="source.value">{{source.label}}</Option>
                                            </template>
                                        </Select>
                                    </template>
                                    <template v-else-if="item.type=='DatePicker'">
                                        <DatePicker @on-change="dateChange($event,item)" v-model="form[item.prop]" :format="item.format" :type="item.dataType" :placeholder="item.placeholder" />
                                    </template>
                                </FormItem>
                                <FormItem v-if="inline" label=" ">
                                    <Button style="margin-top: 2px;" type="primary" @click="search">查询</Button>
                                </FormItem>
                        </div>
                    </Form>
                    <div v-if="inline" class="ag-theme-material" style="min-height: 300px;">
                        <ag-grid-vue 
                            v-if="clickFormData.isTable"
                            style="width: 100%; height: 100%;"
                            :suppressNoRowsOverlay="true"
                            autoSizePadding="10"
                            editType="fullRow"
                            :rowHeight="40"
                            :headerHeight="40"
                            :gridReady="onGridReady"
                            :columnDefs="dialogColumnDefs"
                            :rowData="dialogRowData"
                            >
                        </ag-grid-vue>
                        <div style="display: grid;grid-template-columns: repeat(4,minmax(0,1fr));gap: 20px;padding: 20px;color: white;" v-else>
                            <div style="display: flex;" v-for="(item,index) in clickFormData.resData">
                                <div>{{ item.label }}：</div>
                                <div v-if="item.type=='string'">
                                    {{ isNull(data[item.prop],item) }}{{ item.unit }}
                                </div>
                                <div v-else-if="item.type=='object'">
                                    {{ isNull(item.object[data[item.prop]],item) }}{{ item.unit }}
                                </div>
                            </div>
                        </div>
                        <Spin size="large" fix :show="true" v-if="spinShow"></Spin>
                    </div>
            </div>
            </template>
            <template slot="myfooter" v-if="!inline">
                <Button type="primary" ghost @click="cancel">取消</Button>
                <Button type="primary" @click="save" :loading="dialogLoading">保存</Button>
            </template>
        </ELDialog>
    </div>
</div>
</template>

<script>
import AgGridVueCustomTsx, { ColDefCustom } from 'src/components/agGridCustom/agGridVueCustomTsx';
import CellRenderTsx from 'src/components/agGridComponent/cellRenderTsx';
import ELDialog from 'src/components/ELDialog.vue';
import axios from 'axios';
import { rowData } from './data.js';
import StationSide from '@/pages/systemMessage/components/stationSide.vue';
import { site_component } from 'src/pages/systemMessage/dataView/api.js';
export default {
    components: {
        AgGridVueCustomTsx,
        CellRenderTsx,
        ELDialog,
        StationSide,
    },
    data() {
        return {
            gridApi: null,
            dialogLoading: false,
            title: '',
            inline: false,
            spinShow: false,
            form: {},
            formData: [],
            clickFormData: {},
            dialogColumnDefs: [],
            dialogRowData: [],
            columnDefs: [
                {
                    headerName: '序号',
                    field: 'DateTime',
                    maxWidth: 70,
                    cellRendererFramework: CellRenderTsx,
                    cellRendererFrameworkOpt: {
                        cellRender(h, params) {
                            return h('span', params.rowIndex + 1);
                        },
                    },
                },
                {
                    headerName: '操作',
                    field: 'name',
                    cellRendererFramework: CellRenderTsx,
                    cellRendererFrameworkOpt: {
                        cellRender: (h, params) => {
                            return h(
                                'span',
                                {
                                    class: {
                                        'wqms-cursor': true,
                                        'wqms-link': true,
                                    },
                                    on: {
                                        click: () => this.clickHandler(params),
                                    },
                                },
                                params.value,
                            );
                        },
                    },
                },
            ],
            rowData,
            stationData: {},
            data: {},
            apiData: {},
        };
    },
    methods: {
        isNull(str, item) {
            if (str == null || str == undefined || str == '') {
                return '--';
            } else {
                if (item.toFiexd) {
                    return Number(str).toFixed(item.toFiexd);
                } else {
                    return str;
                }
            }
        },
        onGridReady(params) {
            // this.gridApi = params.api;
            params.api.sizeColumnsToFit();
        },
        nodeClick(item) {
            console.log('点击了节点:', item);
            this.stationData = item;
            site_component({ mn: item.mn }).then(res => {
                if (res.code == 0) {
                    this.apiData['siteComponent'] = res.data.map(e => {
                        return {
                            label: e.name,
                            value: e.key,
                        };
                    });
                }
            });
        },
        dateChange(time, item) {
            if (item.valueType == 'yyyy-MM-dd HH:mm:ss') {
                if (item.dataType == 'date') {
                    this.form[item.model] = time ? time + ' 00:00:00' : '';
                } else if (item.dataType == 'daterange') {
                    this.form[item.start] = time[0] ? time[0] + ' 00:00:00' : '';
                    this.form[item.end] = time[1] ? time[1] + ' 23:59:59' : '';
                } else if (item.dataType == 'datetime') {
                    this.form[item.model] = time ? time : '';
                } else if (item.dataType == 'datetimerange') {
                    this.form[item.start] = time[0] ? time[0] : '';
                    this.form[item.end] = time[1] ? time[1] : '';
                }
            } else if (item.valueType == 'yyyyMMddHHmmss') {
                if (item.dataType == 'date') {
                    this.form[item.model] = time ? (time + '00:00:00').replace(/[:-\s]/g, '') : '';
                } else if (item.dataType == 'daterange') {
                    this.form[item.start] = time[0] ? (time[0] + '00:00:00').replace(/[:-\s]/g, '') : '';
                    this.form[item.end] = time[1] ? (time[1] + '23:59:59').replace(/[:-\s]/g, '') : '';
                } else if (item.dataType == 'datetime') {
                    this.form[item.model] = time ? time.replace(/[:-\s]/g, '') : '';
                } else if (item.dataType == 'datetimerange') {
                    this.form[item.start] = time[0] ? time[0].replace(/[:-\s]/g, '') : '';
                    this.form[item.end] = time[1] ? time[1].replace(/[:-\s]/g, '') : '';
                }
            }
            console.log('=================== time,item', time, item);
        },
        clickHandler({ data }) {
            if (data.onlyRequest) {
                this.$Modal.confirm({
                    title: '提示',
                    content: `<p>是否执行“${data.name}”操作？</p>`,
                    loading: true,
                    onOk: () => {
                        console.log('=================== data', data);
                        axios
                            .post(`${this.stationData.api}${data.api}`)
                            .then(res => {
                                if (res.data.code == 200) {
                                    this.$Message.success('操作成功');
                                    this.cancel();
                                }
                                console.log('=================== res', res);
                            })
                            .catch(err => {
                                this.$Message.error('操作失败');
                            })
                            .finally(() => {
                                this.$Modal.remove();
                            });
                    },
                });
            } else {
                this.title = data.name;
                this.inline = data.inline;
                this.clickFormData = data;
                data.formData.forEach(item => {
                    // 给默认值
                    if (item.value) {
                        this.form[item.prop] = typeof item.value === 'function' ? item.value() : item.value;
                    }
                });
                this.formData = data.formData;
                this.$refs.ELDialogRef.show(data);
            }
        },
        save() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.dialogLoading = true;
                    console.log('=================== save ', this.form, process.env.VUE_APP_BASE_NODE_ENV);
                    axios
                        .post(`${this.stationData.api}${this.clickFormData.api}`, this.form)
                        .then(res => {
                            if (res.data.code == 200) {
                                this.$Message.success('操作成功');
                                this.cancel();
                            } else {
                                this.$Message.error('操作失败');
                            }
                            console.log('=================== res', res);
                        })
                        .catch(err => {
                            this.$Message.error('操作失败');
                        })
                        .finally(() => {
                            this.dialogLoading = false;
                        });
                }
            });
        },
        search() {
            console.log('=================== search ', this.form);
            if (this.clickFormData.formData.length == 0) {
                this.spinShow = true;
                axios
                    .post(`${this.stationData.api}${this.clickFormData.api}`, this.form)
                    .then(res => {
                        console.log('=================== res', res);
                        if (res.data.code == 200) {
                            if (!this.clickFormData.isTable) {
                                this.data = res.data.data;
                            }
                        } else {
                            this.$Message.error('查询失败');
                        }
                    })
                    .catch(err => {
                        this.$Message.error('查询失败');
                    })
                    .finally(() => {
                        this.spinShow = false;
                    });
            } else {
                this.$refs.form.validate(valid => {
                    if (valid) {
                        console.log('=================== search validate', this.form);
                        this.spinShow = true;
                        axios
                            .post(`${this.stationData.api}${this.clickFormData.api}`, this.form)
                            .then(res => {
                                console.log('=================== res', res);
                                if (res.data.code == 200) {
                                    if (!this.clickFormData.isTable) {
                                        this.data = res.data.data;
                                    }
                                } else {
                                    this.$Message.error('查询失败');
                                }
                            })
                            .catch(err => {
                                this.$Message.error('查询失败');
                            })
                            .finally(() => {
                                this.spinShow = false;
                            });
                    }
                });
            }
        },
        resetForm() {
            this.form = {};
            this.formData = [];
            this.data = {};
        },
        cancel() {
            this.dialogLoading = false;
            this.$refs.ELDialogRef.handleClose();
        },
    },
};
</script>

<style scoped lang="less">
</style>
